import { cloneDeep, isEqual } from "lodash";
import { sitesPipelineStore } from "../store";

export const reorderStages = ({ fromIndex, toIndex }: { fromIndex: number; toIndex: number }) => {
  const updatedStageIds = cloneDeep(sitesPipelineStore.orderedStageIds);

  if (!updatedStageIds[fromIndex] || !updatedStageIds[toIndex]) return;

  const [updatedStageId] = updatedStageIds.splice(fromIndex, 1);
  updatedStageIds.splice(toIndex, 0, updatedStageId);

  const hasReordered = !isEqual(updatedStageIds, sitesPipelineStore.orderedStageIds);
  if (hasReordered) {
    sitesPipelineStore.orderedStageIds = updatedStageIds;
  }
};
